import React, {useEffect, useState} from "react";
import {Accordion} from "react-bootstrap";
import AccordionItem from "./AccordionItem";

const CustomAccordion = ({items, defaultActiveKey}) => {

    const [activeKey, setActiveKey] = useState(defaultActiveKey);
    const [scrollTarget, setScrollTarget] = useState(null);

    const handleScrollAfterOpen = () => {
        if (scrollTarget && scrollTarget.current) {
            window.scrollTo({
                top: scrollTarget.current.offsetTop + 100, // Adjust the offset if needed
                behavior: "smooth"
            });
            setScrollTarget(null); // Clear the target once scrolling is done
        }
    };

    useEffect(() => setActiveKey(defaultActiveKey), [defaultActiveKey])


    return (
        <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
            {
                items.map(item =>
                    <AccordionItem
                        title={item.title}
                        eventKey={item.eventKey}
                        activeKey={activeKey}
                        completed={item.completed}
                        completable={item.completable}
                        asButton={item.asButton}
                        ref={item.ref}
                        enable={item.enable}
                        onEntered={handleScrollAfterOpen}>
                        {item.content}
                    </AccordionItem>
                )
            }
        </Accordion>
    );
};

export default CustomAccordion;
